module.exports = __webpack_public_path__ + "svg/multi-mid-button.d5e8d403ee33a2ca54254f7de763193f.svg";